import { useTranslation } from "react-i18next";

import { useAuth } from "../../../hooks/useAuth";
import { useIntercomCustom } from "../../../hooks/useIntercomCustom";
import { useLeftPanel } from "../../../hooks/useLeftPanel";
import {
  LeftPanelUserSettingsContainer,
  UserSettingOption,
} from "./LeftPanelUserSettings.style";

export function LeftPanelUserSettings() {
  const { t } = useTranslation();
  const { isMobileUserSettingsMenuOpen, setIsMobileUserSettingsMenuOpen } =
    useLeftPanel();
  const { signOut } = useAuth();
  const { setIsIntercomOpen } = useIntercomCustom();

  const handleSignOutClick = () => signOut();

  const handleSupportClick = () => {
    setIsMobileUserSettingsMenuOpen(false);
    setIsIntercomOpen((prevState) => !prevState);
  };

  return (
    <LeftPanelUserSettingsContainer isOpen={isMobileUserSettingsMenuOpen}>
      <UserSettingOption
        type="button"
        onClick={() => window.location.assign("/settings")}
      >
        {t("userSettings_settings")}
      </UserSettingOption>
      <UserSettingOption type="button" onClick={handleSupportClick}>
        {t("userSettings_support")}
      </UserSettingOption>
      <UserSettingOption type="button" onClick={handleSignOutClick}>
        {t("userSettings_signOut")}
      </UserSettingOption>
    </LeftPanelUserSettingsContainer>
  );
}
